module.exports = __webpack_public_path__ + "src/images/measurements/waistLengthFront.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/waistLengthFront.jpg
// module id = 1163
// module chunks = 0